import type { AppDefinition } from '../../types/apps';

export const GoogleDriveFileAppDefinition: AppDefinition = {
  appId: 'google-drive-file',
  name: 'Google Drive File',
  version: '1.0.0',
  description: 'View Google Drive files in an iframe',
  icon: {
    type: 'iconify',
    iconifyIcon: 'simple-icons:googledrive',
  },
  events: {},
  entityTypes: [
    // Legacy type
    'GoogleDriveFile',
    // Hierarchical types
    'External.GoogleDrive',
    'External.GoogleDrive.Document',
    'External.GoogleDrive.Spreadsheet',
    'External.GoogleDrive.Presentation',
    'External.GoogleDrive.Form',
    'External.GoogleDrive.Drawing',
    'External.GoogleDrive.PDF',
    'External.GoogleDrive.Image',
    'External.GoogleDrive.Video',
    'External.GoogleDrive.Audio',
  ],
  component: 'google-drive-file',
  requiresProps: false,
  requiresEntity: true,
  actions: {},
  entityIcons: {
    GoogleDriveFile: {
      type: 'iconify',
      iconifyIcon: 'simple-icons:googledrive',
    },
  },
};

export default GoogleDriveFileAppDefinition;

